/* eslint-disable import/no-anonymous-default-export */
import { SET_SCROLL_DISTANCE } from '../actionConstants';

export default (state = 1, action) => {
  switch (action.type) {
    case SET_SCROLL_DISTANCE:
      return action.payload;
    default:
      return state;
  }
};
